import React from "react";
import { ViewTreatMent } from "../../../secondary";
import styles from "./SecondaryDressing.module.scss";
import { useSecondaryDressing } from "./hooks/useSecondaryDressing";
import constants from "../../../../constants/constants.json";

export const SecondaryDressing = ({ interventionId, formularyId }) => {
  const { editData, secSelectData, closeWarning, dropValue, setDropValue, setCloseWarning, saveData, yesFn, noFn } = useSecondaryDressing({
    interventionId,
    formularyId,
  });

  return (
    <>
      {closeWarning && (
        <>
          <div className={`${styles.warning}`}>
            <h6>
              {"Based on your Primary dressing selection, Secondary dressing is not recommended."} <br />
              {"Are you sure you would like to proceed with your Secondary dressing selection?"} <br />
              <button onClick={yesFn}>Yes</button>
              <button onClick={noFn}>No</button>
            </h6>
          </div>
        </>
      )}
      <ViewTreatMent
        editData={editData}
        viewData={secSelectData}
        noDataMessage={constants.assessment.noSecondaryDressing}
        saveData={saveData}
        dressing="secondary"
        setCloseWarningSec={setCloseWarning}
        dropValue={dropValue}
        setGetValueDrop={setDropValue}
      />
    </>
  );
};
